import React from 'react';
import PropTypes from 'prop-types';
import urlParse from 'url-parse';

class OptimizedImage extends React.Component {
  constructor(props) {
    super(props);

    this.imageDidMouseEnter = this.imageDidMouseEnter.bind(this);
    this.imageDidMouseLeave = this.imageDidMouseLeave.bind(this);
  }

  imageDidMouseEnter(e) {
    e.preventDefault();
    if (typeof this.props.imageDidMouseEnter === 'function') {
      this.props.imageDidMouseEnter();
    }
  }

  imageDidMouseLeave(e) {
    e.preventDefault();
    if (typeof this.props.imageDidMouseLeave === 'function') {
      this.props.imageDidMouseLeave();
    }
  }

  attachQuery(imageUrl, query) {
    const image = urlParse(imageUrl);
    if (this.isTargetHost(image.host) && this.isTargetExtention(imageUrl) && query) {
      const newQuery = image.query ? `${image.query}&${query}` : `?${query}`;
      image.set('query', newQuery);
    }

    return image.href;
  }

  isTargetExtention(imageUrl) {
    return !!imageUrl.match(/\.(jpg|jpeg|png|gif)/i);
  }

  isTargetHost(host) {
    return host === 'cdn.spacemarket.net' || host === 'cdn-sandbox.spacemarket.com';
  }

  render() {
    const src = this.props.src;
    const alt = this.props.alt;
    const width = this.props.width;
    const height = this.props.height;
    const className = this.props.className;
    const webpSrc = !src ? null : this.attachQuery(src, 'of=webp');

    return(
      <picture>
        <source type="image/webp" srcSet={webpSrc} />
        <img
          onMouseEnter={this.imageDidMouseEnter}
          onMouseLeave={this.imageDidMouseLeave}
          width={width}
          height={height}
          src={src}
          alt={alt}
          className={className}
        />
      </picture>
    );
  }
}

OptimizedImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  imageDidMouseEnter: PropTypes.func,
  imageDidMouseLeave: PropTypes.func,
};

OptimizedImage.defaultProps = {
  className: '',
  width: null,
  height: null,
  imageDidMouseEnter: null,
  imageDidMouseLeave: null,
};

export default OptimizedImage;



// WEBPACK FOOTER //
// ./app/javascript/components/shared/OptimizedImage.jsx